import glideCarouselModule from "../glideCarouselModule";
import Glide from '@glidejs/glide';

function controlService($window, $log, glideConstants) {
    "ngInject";

    let inClick = false;

    function updateDisableMoves(carouselControl) {
        const { currentPageNumber, currentTotalPages } = carouselControl;
        carouselControl.disableRightMove = currentPageNumber === (currentTotalPages - 1);
        carouselControl.disableLeftMove = currentPageNumber === 0;

    }

    function setupForward(carouselInstance, carouselControl) {
        if (!carouselInstance || !carouselControl) {
            return;
        }
        if (inClick) return;
        inClick = true;

        let { currentPageNumber, currentNumSlidesToMove, currentTotalPages, disableRightMove } = carouselControl;
        if (currentPageNumber < currentTotalPages - 1 && !disableRightMove) {
            currentPageNumber++;
            const rightMove = currentPageNumber * currentNumSlidesToMove; // start with 0
            const goRightMove = `=${rightMove}`;
            carouselInstance.go(goRightMove);
            carouselControl.currentPageNumber = currentPageNumber;
            $log.debug("------------- setupForward ------------------ currentPageNumber" + currentPageNumber);
        }

        updateDisableMoves(carouselControl);
    }

    function setupBackward(carouselInstance, carouselControl) {
        if (!carouselInstance || !carouselControl) {
            return;
        }

        if (inClick) return;
        inClick = true;

        let { currentPageNumber, currentNumSlidesToMove, disableLeftMove } = carouselControl;

        if (currentPageNumber > 0 && !disableLeftMove) {
            currentPageNumber--;
            const leftMove = currentPageNumber * currentNumSlidesToMove;
            const goLeftMove = `=${leftMove}`;
            carouselInstance.go(goLeftMove);
            carouselControl.currentPageNumber = currentPageNumber;
            $log.debug("------------- setupBackward ------------------ currentPageNumber" + currentPageNumber);
        }

        updateDisableMoves(carouselControl);
    }

    function isCurrentWidthBetweenBreakpoints(currentWidth, allBreakpoints, i) {
        const length = allBreakpoints.length;
        return currentWidth <= allBreakpoints[i] && ((i + 1) === length || currentWidth > allBreakpoints[i + 1]);
    }

    return {
        setupCarouselControl: function (lengthOfSlides, carouselConstants) {
            carouselConstants = carouselConstants || glideConstants;
            carouselConstants.glideControl.totalSlides = lengthOfSlides;

            const { breakpointWidth, glideControl, options } = carouselConstants;
            const { defaultNumItemsToMove, currentPageNumber } = glideControl;

            const currentWidth = $window.innerWidth;
            const allBreakpoints = breakpointWidth.sort((a, b) => { return b - a });
            allBreakpoints.some(function (breakpoint, i) {
                if (isCurrentWidthBetweenBreakpoints(currentWidth, allBreakpoints, i)) {
                    glideControl.currentNumSlidesToMove = options.breakpoints[breakpoint].perView;
                }
            });
            glideControl.currentNumSlidesToMove = glideControl.currentNumSlidesToMove || defaultNumItemsToMove;
            const currentTotalPages = Math.ceil(lengthOfSlides / glideControl.currentNumSlidesToMove);
            glideControl.currentTotalPages = currentTotalPages;
            glideControl.disableLeftMove = currentPageNumber === 0;
            glideControl.disableRightMove = currentPageNumber === (currentTotalPages - 1);

            return Object.assign({}, glideControl);
        },

        listenToResize: function (carouselInstance, carouselConstants, carouselControl) {
            if (!carouselInstance || !carouselControl) {
                return;
            }
            carouselConstants = carouselConstants || glideConstants;
            const { breakpointWidth, glideControl, options } = carouselConstants;
            const { totalSlides } = glideControl;

            const allBreakpoints = breakpointWidth.sort((a, b) => { return b - a });
            const length = allBreakpoints.length;
            carouselInstance.on('resize', function () {
                const currentWidth = $window.innerWidth;

                allBreakpoints.some(function (breakpoint, i) {
                    if (isCurrentWidthBetweenBreakpoints(currentWidth, allBreakpoints, i)) {
                        const { currentNumSlidesToMove, currentPageNumber } = carouselControl;
                        const currentIndex = currentNumSlidesToMove * currentPageNumber;
                        $log.debug("resize event from glide --- $window.innerWidth ---" + $window.innerWidth);
                        const nextNumSlidesToMove = options.breakpoints[breakpoint].perView;
                        if (currentNumSlidesToMove !== nextNumSlidesToMove) {
                            carouselControl.currentNumSlidesToMove = nextNumSlidesToMove;
                            carouselControl.currentPageNumber = Math.floor(currentIndex / nextNumSlidesToMove);
                            carouselControl.currentTotalPages = Math.ceil(totalSlides / nextNumSlidesToMove);
                        }
                    }
                });
            });
        },

        backward: function (carouselInstance, carouselControl) {
            return function () {
                $log.debug("------------- backward ------------------");
                setupBackward(carouselInstance, carouselControl);
            }
        },

        forward: function (carouselInstance, carouselControl) {
            return function () {
                $log.debug("------------- forward ------------------");
                setupForward(carouselInstance, carouselControl);
            }
        },

        initializeGlideCarousel: function (selector, carouselConstants, carouselControl) {
            const glideControl = {
                startAt: carouselControl.startAt || 0,
                perView: carouselControl.defaultNumItemsToMove || 0,
                animationDuration: carouselControl.animationDuration || 300,
                perTouch: carouselControl.defaultNumItemsToMove || false,
                swipeThreshold: carouselControl.swipeThreshold || 20,
                touchRatio: carouselControl.touchRatio || 0.8
            }
            Object.assign(glideControl, carouselConstants.options);
            const glideInstance = new Glide(selector, glideControl);
            glideInstance.mount();

            glideInstance.on(['move.after'], function () {
                $log.debug("------------- move.after ------------------");
                inClick = false;
            });
            return glideInstance;
        }
    }
}

glideCarouselModule.service("controlService", controlService);

export default controlService;
